import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { httpClient } from "../services/http/httpClient";
function RowCounter(props) {
    const { totalSize, endpoint, baseUrl, filter, loading } = props;
    const [count, setCount] = useState(null);
    const fetchRowTotal = () => {
        httpClient()
            .get("/" + endpoint + ":count", {
            params: {
                filter: filter,
            },
            baseURL: baseUrl,
        })
            .then((res) => {
            setCount(res.data.meta.total);
        });
    };
    useEffect(() => {
        if (!loading) {
            if (totalSize === 10000) {
                fetchRowTotal();
            }
            else {
                setCount(totalSize);
            }
        }
    }, [loading]);
    const addTotalText = (total) => {
        if (total === 1) {
            return "1 Row";
            // add a plus for elastic search default (results cap at 10,000)
        }
        else if (total === 10000) {
            return "10,000+ Rows";
        }
        return total.toLocaleString() + " Rows";
    };
    if (count === null)
        return _jsx(_Fragment, {});
    return _jsx("span", { className: "tol-total", children: addTotalText(count) });
}
export default RowCounter;
